/**
 * Background-tasks WS plugin — maps task.started / task.updated to the
 * taskUpserted action. Shape mirrors todosWsPlugin.
 */

import { WsPluginMap } from '@/infra/ws/root-saga';
import { BackgroundTask } from '@/infra/types/domain';
import { TASK_UPSERTED } from './ducks';

type TaskPayload = { task: BackgroundTask };

export const backgroundTasksWsPlugin: WsPluginMap = {
  'task.started': (msg) => {
    const data = msg.data as TaskPayload;
    if (!data?.task) return null;
    return { type: TASK_UPSERTED, payload: data.task };
  },
  'task.updated': (msg) => {
    const data = msg.data as TaskPayload;
    if (!data?.task) return null;
    return { type: TASK_UPSERTED, payload: data.task };
  },
};
